import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import GoBack from "../../../component/molecules/goBack";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import MainInput from "../../../component/atoms/input/mainInput";
import Radio from "../../../component/atoms/input/radio";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import AlarmApi from "../../../api/alarm.api";

function AlarmCreate() {
  // import
  const navigate = useNavigate();

  const [alarmData, setAlarmData] = useState({
    title: "",
    content: "",
    alarmType: "SERVICE",
  });

  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveFunc = async () => {
    try {
      await AlarmApi.create(alarmData);
      setSaveModalOpen(false);
      navigate(-1);
      toast(toastMsg.create);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>추가하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>유형*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={""}
                    valueText={"서비스알림"}
                    checked={alarmData.alarmType === "SERVICE"}
                    onChange={() => {
                      setAlarmData({
                        ...alarmData,
                        alarmType: "SERVICE",
                      });
                    }}
                  />
                  <Radio
                    id={""}
                    valueText={"광고성알림"}
                    checked={alarmData.alarmType === "AD"}
                    onChange={() => {
                      setAlarmData({
                        ...alarmData,
                        alarmType: "AD",
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>제목*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"제목을 입력해주세요"}
                  value={alarmData.title}
                  onChange={(e) =>
                    setAlarmData({ ...alarmData, title: e.target.value })
                  }
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>내용*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "730px",
                  }}
                  type={"text"}
                  placeholder={"내용을 입력해주세요"}
                  value={alarmData.content}
                  onChange={(e) =>
                    setAlarmData({ ...alarmData, content: e.target.value })
                  }
                />
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                text="등록하기"
                onClick={() => {
                  if (!alarmData.title.trim())
                    return toast("제목을 입력해주세요.");
                  if (!alarmData.content.trim())
                    return toast("내용을 입력해주세요.");

                  setSaveModalOpen(true);
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : null}
    </>
  );
}

export default AlarmCreate;
